<div class="field-builder-container">

  @if (currentMode === FieldMode.SAVING) {
    <div class="field-custom-container">
      <div class="saving-field-container">
        <div class="field-row fx-layout-row fx-wrap fx-justify-start fx-align-baseline">
          <div class="field-label fx-flex-100-33-percent">
            {{ fieldGroup.label }}
          </div>
          <div class="field-container fx-flex-100-66-percent fx-layout-col">
            {{ 'LABEL.SAVE_IN_PROGRESS' | translate }}
          </div>
        </div>
      </div>
    </div>
  }

  @if (currentMode === FieldMode.EMPTY) {
    <div class="field-custom-container">
      <div class="empty-field-container">
        <div
          [ngClass]="{'no-value': !accessManager.hasAllNeededPermissions(permissionsForEdition) || !preconditionsForEdition}"
          class="field-row fx-layout-row fx-wrap fx-justify-start fx-align-baseline">
          <div class="field-label fx-flex-100-33-percent">
            {{ fieldGroup.label }}
          </div>
          <div class="field-container fx-layout-col fx-flex-100-66-percent">
            <div class="empty-value">
              @if (accessManager.hasAllNeededPermissions(permissionsForEdition) && preconditionsForEdition) {
                <add-field-link (click)="onActivate($event)" (keyup.enter)="onActivate($event)"
                                [inputMessage]="fieldGroup.emptyLabel"></add-field-link>
              } @else {
                {{ appConfig.EMPTY_FIELD_VALUE }}
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  }

  @if (currentMode === FieldMode.READ && !isCreatingEntity) {
    <div class="field-custom-container">
      <div class="read-field-container">
        <div
          [ngClass]="{'read-value': !accessManager.hasAllNeededPermissions(permissionsForEdition) || !preconditionsForEdition}"
          class="field-row fx-layout-row fx-wrap fx-justify-start fx-align-baseline">
          <div class="field-label fx-flex-100-33-percent">
            {{ fieldGroup.label }}
          </div>
          <div class="field-container fx-layout-col fx-gap-5 fx-flex-100-66-percent">
            <div (click)="onActivate($event)" (keyup.enter)="onActivate($event)"
                 [ngClass]="{'read-value': accessManager.hasAllNeededPermissions(permissionsForEdition) && preconditionsForEdition, 'computed': !(accessManager.hasAllNeededPermissions(permissionsForEdition) && preconditionsForEdition)}"
                 tabindex="0">
              <div class="formatted-string">
                {{ formatAddress() }}
              </div>
              @if (accessManager.hasAllNeededPermissions(permissionsForEdition)) {
                <span
                  class="overlay-icon">
                  @if (preconditionsForEdition) {
                    <i class="mdi mdi-pencil selectable"></i>
                  } @else {
                    <i [matTooltipPosition]="'below'" [matTooltip]="'TOOLTIP.READ_ONLY_VALUE' | translate" class="mdi mdi-pencil-off tooltip-icon"></i>
                  }
                </span>
              }
            </div>
            <div class="fx-layout-row">
              <div (click)="onActivate($event)" class="map-zone fx-flex-100-50-percent">
                <single-asset-map [allowZooming]="false"
                  [allowMarkerDragging]="false"
                  [allowPanning]="false"
                  [allowClicking]="false"
                  [address]="completeAddress"
                  [permissionsForEdition]="permissionsForEdition"
                  height="250px"
                  width="100%">
                </single-asset-map>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }

  @if (currentMode === FieldMode.EDIT || isCreatingEntity) {
    <div class="field-custom-container">
      <div class="edit-field-container">
        <div class="field-row fx-layout-row fx-wrap fx-justify-start fx-align-baseline">
          <!-- label -->
          <div class="field-label fx-flex-100-33-percent">
            {{ fieldGroup.label }}
          </div>

          <!-- fields -->
          <div class="field-container fx-flex-100-66-percent fx-layout-col">
            <form autocomplete="off" class="fx-layout-col" [formGroup]="form">

              <div class="streetNumber street fx-layout-row fx-gap-10">
                @if(streetNumberFieldConfig) {
                  <div class="fx-flex-30-percent">
                    <mat-form-field appearance="outline">
                      <mat-label>{{ streetNumberFieldConfig.label }}</mat-label>
                      <input formControlName="streetNumber" matInput inputFieldBuilderAutoFocus type="text">
                      @if (streetNumberFieldConfig.suffixType) {
                        <span matTextSuffix>
                          {{ streetNumberFieldConfig.suffixType | translate }}
                        </span>
                      }
                      @if (streetNumberFieldConfig.tooltip) {
                        <mat-icon [matTooltipPosition]="'after'"
                                  [matTooltip]="streetNumberFieldConfig.tooltip"
                                  matIconSuffix>help
                        </mat-icon>
                      }
                      @for (validator of getErroredValidators('streetNumber'); track validator.type) {
                        <mat-error>
                          {{ 'ERROR.FIELD_' + validator.type | uppercase | translate: {value: validator.definition} }}
                        </mat-error>
                      }
                    </mat-form-field>
                  </div>
                }

                @if(streetFieldConfig) {
                  <div class="fx-flex-70-percent">
                    <mat-form-field appearance="outline">
                      <mat-label>{{ streetFieldConfig.label }}</mat-label>
                      <input formControlName="street" matInput type="text">
                      @if (streetFieldConfig.suffixType) {
                        <span matTextSuffix>
                          {{ streetFieldConfig.suffixType | translate }}
                        </span>
                      }
                      @if (streetFieldConfig.tooltip) {
                        <mat-icon [matTooltipPosition]="'after'"
                                  [matTooltip]="streetFieldConfig.tooltip"
                                  matIconSuffix>help
                        </mat-icon>
                      }
                      @for (validator of getErroredValidators('street'); track validator.type) {
                        <mat-error>
                          {{ 'ERROR.FIELD_' + validator.type | uppercase | translate: {value: validator.definition} }}
                        </mat-error>
                      }
                    </mat-form-field>
                  </div>
                }
              </div>

              <div class="postalcode city country fx-layout-row fx-gap-10">
                @if (postalCodeFieldConfig) {
                  <div class="fx-flex-20-percent">
                    <mat-form-field appearance="outline">
                      <mat-label>{{ postalCodeFieldConfig.label }}</mat-label>
                      <input formControlName="postalCode" matInput type="text">
                      @if (postalCodeFieldConfig.suffixType) {
                        <span matTextSuffix>
                          {{ postalCodeFieldConfig.suffixType | translate }}
                        </span>
                      }
                      @if (postalCodeFieldConfig.tooltip) {
                        <mat-icon [matTooltipPosition]="'after'"
                                  [matTooltip]="postalCodeFieldConfig.tooltip"
                                  matIconSuffix>help
                        </mat-icon>
                      }
                      @for (validator of getErroredValidators('postalCode'); track validator.type) {
                        <mat-error>
                          {{ 'ERROR.FIELD_' + validator.type | uppercase | translate: {value: validator.definition} }}
                        </mat-error>
                      }
                    </mat-form-field>
                  </div>
                }

                @if(cityFieldConfig) {
                  <div class="fx-flex-40-percent">
                    <mat-form-field appearance="outline">
                      <mat-label>{{ cityFieldConfig.label }}</mat-label>
                      <input formControlName="city" matInput type="text">
                      @if (cityFieldConfig.suffixType) {
                        <span matTextSuffix>
                          {{ cityFieldConfig.suffixType | translate }}
                        </span>
                      }
                      @if (cityFieldConfig.tooltip) {
                        <mat-icon [matTooltipPosition]="'after'"
                                  [matTooltip]="cityFieldConfig.tooltip"
                                  matIconSuffix>help
                        </mat-icon>
                      }
                      @for (validator of getErroredValidators('city'); track validator.type) {
                        <mat-error>
                          {{ 'ERROR.FIELD_' + validator.type | uppercase | translate: {value: validator.definition} }}
                        </mat-error>
                      }
                    </mat-form-field>
                  </div>

                }

                @if(countryFieldConfig) {
                  <div class="fx-flex-40-percent">
                    <mat-form-field appearance="outline">
                      <mat-label>{{ countryFieldConfig.label }}</mat-label>
                      <mat-select formControlName="country">
                        <mat-option [value]="''">{{ 'LABEL.UNDEFINED' | translate }}</mat-option>
                        @for (fieldValue of countryFieldConfig.field.fieldValues; track fieldValue) {
                          <mat-option
                            [value]="fieldValue">{{ 'VALUE.COUNTRY_' + fieldValue | translate }}
                          </mat-option>
                        }
                      </mat-select>
                      @if (countryFieldConfig.suffixType) {
                        <span matTextSuffix>
                          {{ countryFieldConfig.suffixType | translate }}
                        </span>
                      }
                      @if (countryFieldConfig.tooltip) {
                        <mat-icon [matTooltipPosition]="'after'"
                                  [matTooltip]="countryFieldConfig.tooltip"
                                  matIconSuffix>help
                        </mat-icon>
                      }
                      @for (validator of getErroredValidators('country'); track validator.type) {
                        <mat-error>
                          {{ 'ERROR.FIELD_' + validator.type | uppercase | translate: {value: validator.definition} }}
                        </mat-error>
                      }
                    </mat-form-field>
                  </div>
                }
              </div>

              <div class="location-link">
                <!-- Location link -->
                <span tabindex="0" (click)="map.updateAddressCoordinates()">
                  {{ 'LABEL.LOCATE' | translate }}
                </span>
              </div>

              <div class="fx-layout-row">
                <div class="map-zone fx-flex-100-60-percent">
                  <single-asset-map [allowZooming]="true"
                    [allowClicking]="true"
                    [allowPanning]="accessManager.hasAllNeededPermissions(permissionsForEdition) && preconditionsForEdition"
                    [allowMarkerDragging]="accessManager.hasAllNeededPermissions(permissionsForEdition) && preconditionsForEdition"
                    [address]="completeAddress"
                    [permissionsForEdition]="permissionsForEdition"
                    (positionUpdated)="updateLatLong($event)"
                    height="350px"
                    width="100%">
                  </single-asset-map>
                </div>
              </div>

              @if (latitudeFieldConfig && longitudeFieldConfig) {
                <mat-accordion displayMode="flat" togglePosition="before">
                  <mat-expansion-panel id="gps-coordinates">
                    <!-- GPS coordinates link -->
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        {{ 'LABEL.GPS_COORDINATES' | translate }}
                      </mat-panel-title>
                    </mat-expansion-panel-header>

                    <div class="latitude longitude fx-layout-row fx-gap-10">
                      <div class="fx-flex-49-30-percent">
                        <mat-form-field appearance="outline">
                          <mat-label>{{ latitudeFieldConfig.label }}</mat-label>
                          <input (beforeinput)="validateKeypressEvent($event)" (paste)="validatePasteEvent($event)"
                                 formControlName="latitude" matInput
                                 type="text">
                          @if (latitudeFieldConfig.suffixType) {
                            <span matTextSuffix>
                              {{ latitudeFieldConfig.suffixType | translate }}
                            </span>
                          }
                          @if (latitudeFieldConfig.tooltip) {
                            <mat-icon [matTooltipPosition]="'after'"
                                      [matTooltip]="latitudeFieldConfig.tooltip"
                                      matIconSuffix>help
                            </mat-icon>
                          }
                          @for (validator of getErroredValidators('latitude'); track validator.type) {
                            <mat-error>
                              {{ 'ERROR.FIELD_' + validator.type | uppercase | translate: {value: validator.definition} }}
                            </mat-error>
                          }
                        </mat-form-field>
                      </div>

                      <div class="fx-flex-49-30-percent">
                        <mat-form-field appearance="outline">
                          <mat-label>{{ longitudeFieldConfig.label }}</mat-label>
                          <input (beforeinput)="validateKeypressEvent($event)" (paste)="validatePasteEvent($event)"
                                 formControlName="longitude"
                                 matInput
                                 type="text">
                          @if (longitudeFieldConfig.suffixType) {
                            <span matTextSuffix>
                              {{ longitudeFieldConfig.suffixType | translate }}
                            </span>
                          }
                          @if (longitudeFieldConfig.tooltip) {
                            <mat-icon [matTooltipPosition]="'after'"
                                      [matTooltip]="longitudeFieldConfig.tooltip"
                                      matIconSuffix>help
                            </mat-icon>
                          }
                          @for (validator of getErroredValidators('longitude'); track validator.type) {
                            <mat-error>
                              {{ 'ERROR.FIELD_' + validator.type | uppercase | translate: {value: validator.definition} }}
                            </mat-error>
                          }
                        </mat-form-field>
                      </div>

                    </div>
                  </mat-expansion-panel>
                </mat-accordion>
              }
            </form>

            <div class="button-container fx-layout-row fx-justify-end fx-align-center">
              <!-- cancel + save -->
              <button (click)="onClickCancel()" (keyup.escape)="onEscapeCancel($event)"
                mat-stroked-button>{{ 'BUTTON.CANCEL' | translate }}
              </button>
              <button (click)="onClickSave()" (keyup.escape)="onEscapeCancel($event)" [disabled]="!form.valid"
                color="accent"
                mat-raised-button>{{ 'BUTTON.SAVE' | translate }}
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>
  }

</div>
